/**
 * @typedef LectureCategory
 * @property {string}       _id             인덱스
 * @property {string}       _parent         부모인덱스
 * @property {string[]}     _parents        부모인덱스
 * @property {string}       code            코드
 * @property {string}       name            명칭
 * @property {number}       depth           뎁스
 * @property {number}       index           순서
 * @property {string}       [fullName]      풀네임
 * @property {object}       main            메인설정
 * @property {boolean}      main.isActive   메인노출
 * @property {number|null}  main.index      메인순서
 */

/**
 * @param {LectureCategory} category
 * @returns {LectureCategory}
 */
export function initLectureCategory(category = {}) {
    return {
        ...(category || {}),

        _id: category?._id || null,

        _parent: category?._parent || null,
        _parents: [...(category?._parents || [])],

        code: category?.code || null,
        name: category?.name || null,

        depth: category?.depth || 1,
        index: category?.index || 0,

        main: {
            ...(category?.main || {}),
            isActive: category?.main?.isActive || false,
            index: category?.main?.index || null,
        },
    };
}

/**
 * @typedef LectureCategoryState
 * @property {LectureCategory[]}    items   카테고리
 * @property {boolean}              loading
 */

/**
 * @param {LectureCategoryState} state
 * @returns {LectureCategoryState}
 */
export function initLectureCategoryState(state = {}) {
    return {
        ...(state || {}),

        items: [...(state?.items || [])],
        loading: state?.loading ?? false,
    };
}
